// AgriGamesHome.jsx
// Hub page listing all 6 Agri game categories and launching the selected game.

import React, { useState } from 'react';
import AgriSoloSeedMatcher from './AgriSoloSeedMatcher';
import AgriTycoon from './AgriTycoon';
import KrishiQuest from './KrishiQuest';
import HarvestHeroes from './HarvestHeroes';
import FarmOlympics from './FarmOlympics';
import AgriMetaverse from './AgriMetaverse';



// Categories
const categories = [
  { id: 1, title: 'Agri Tycoon', desc: 'Run your own virtual farm economy and markets.', component: <AgriTycoon /> },
  { id: 2, title: 'Krishi Quest', desc: 'Adventure quests solving real farming problems.', component: <KrishiQuest/> },
  { id: 3, title: 'Harvest Heroes', desc: 'Seasonal crop competitions with challenges.', component: <HarvestHeroes/> },
  { id: 4, title: 'Agri Puzzle Mania', desc: 'Casual farm-themed match-3 puzzle game.', component: <AgriSoloSeedMatcher /> },
  { id: 5, title: 'Farm Olympics', desc: 'Mini skill challenges: ploughing, milking, tractor race.', component: <FarmOlympics/> },
  { id: 6, title: 'Agri Metaverse', desc: 'Virtual farming village & trading hub.', component: <AgriMetaverse/> },
];

export default function AgriGamesHome() {
  const [activeGame, setActiveGame] = useState(null);

  if (activeGame) {
    return (
      <div style={{padding:20}}>
        <button onClick={() => setActiveGame(null)} style={{marginBottom:12, padding:'6px 12px', borderRadius:8, border:'1px solid #ccc', cursor:'pointer'}}>← Back to Games Home</button>
        {activeGame.component}
      </div>
    );
  }

  return (
    <div style={{padding:20, maxWidth:1000, margin:'0 auto'}}>
      <h1 className="text-xl" style={{marginTop:0}}>🎮 Think5Whys Rural/Agri Games</h1>
      {/* <p>Select a game category below to play or explore:</p> */}

      <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(260px, 1fr))', gap:16, marginTop:16}}>
        {categories.map(cat => (
          <div key={cat.id} style={{background:'#fff', borderRadius:12, padding:16, boxShadow:'0 4px 12px rgba(0,0,0,0.08)', display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
            <h3 className="text-black text-lg" style={{margin:'0 0 8px 0'}}>{cat.title}</h3>
            <p style={{flexGrow:1, fontSize:14, margin:'0 0 12px 0', color:'#444'}}>{cat.desc}</p>
            {cat.component ? (
              <button onClick={() => setActiveGame(cat)} className="flex-1 justify-center w-20 items-center" style={{padding:'8px 12px', border:'none', borderRadius:8, background:'#2e7d32', color:'#fff', cursor:'pointer'}}>▶ Play</button>
            ) : (
              <button disabled style={{padding:'8px 12px', border:'none', borderRadius:8, background:'#ccc', color:'#666'}}>Coming Soon</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
